import { render, staticRenderFns } from "./GoodsPriceTrend.vue?vue&type=template&id=4cbd5010"
import script from "./GoodsPriceTrend.vue?vue&type=script&lang=js"
export * from "./GoodsPriceTrend.vue?vue&type=script&lang=js"
import style0 from "./GoodsPriceTrend.vue?vue&type=style&index=0&id=4cbd5010&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports